{
	"title": "Toegang geweigerd (403)",
	"description": "Je hebt niet de benodigde rechten om deze pagina te openen. Zorg ervoor dat je bent ingelogd met een account met de juiste machtigingen. Het wissen van je browsergegevens kan het probleem ook oplossen. Als je nog steeds toegang nodig hebt, neem dan contact op met de systeembeheerder.",
	"secondaryButtonTitle": "Uitloggen"
}
